import { useAuth } from '@/app/context';
import { useEffect, useRef, useState } from 'react';

interface UseRequirePermissionsOptions {
  permissions: string[];
  onUnauthorized?: () => void;
}

export function useRequirePermissions({
  permissions,
  onUnauthorized,
}: UseRequirePermissionsOptions) {
  const { checkUserPermissions, loading, isAuthenticated } = useAuth();
  const [hasPermission, setHasPermission] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  const permissionsKey = permissions.join(',');
  const onUnauthorizedRef = useRef(onUnauthorized);
  onUnauthorizedRef.current = onUnauthorized;

  useEffect(() => {
    if (loading) return;

    const checkPermission = async () => {
      setIsChecking(true);
      try {
        const hasAccess = await checkUserPermissions(permissionsKey.split(','));
        setHasPermission(hasAccess);

        if (!hasAccess) {
          onUnauthorizedRef.current?.();
        }
      } catch (error) {
        console.error('Erro ao verificar permissões:', error);
        setHasPermission(false);
        onUnauthorizedRef.current?.();
      } finally {
        setIsChecking(false);
      }
    };

    checkPermission();
  }, [permissionsKey, checkUserPermissions, loading, isAuthenticated]);

  return {
    hasPermission,
    isChecking,
  };
}
